import { planClassOverlap } from './classOverlapFix';

export const inspectorStudentText = (student) => String(student?.refined_sentence || student?.content || '');

/**
 * 검사기 다중 검사 반 점검. 스캔·사진은 글자 인식 오차가 있어 '같은 문장'이라고 단정하지 않고 '거의 같은 문장'으로 묶는다.
 */
export const planInspectorOverlap = (results = [], { approximate = false } = {}) => {
  const plan = planClassOverlap(results.map(inspectorStudentText));
  if (!approximate) return plan;
  const near = (sentence) => ({ ...sentence, tier: 'near' });
  return {
    ...plan,
    targets: plan.targets.map((target) => ({ ...target, sentences: target.sentences.map(near) })),
    summary: {
      ...plan.summary,
      sameGroups: 0,
      nearGroups: plan.summary.sameGroups + plan.summary.nearGroups,
    },
  };
};

/** 엑셀 '겹침' 칸: 고칠 학생만, 바꿀 문장을 그대로 적는다. */
export const overlapExcelCell = (plan, index) => {
  const target = plan?.targets?.find((item) => item.index === index);
  if (!target) return '';
  return target.sentences
    .map((sentence) => `[${sentence.people - 1}명과 ${sentence.tier === 'same' ? '같음' : '거의 같음'}] ${sentence.text}`)
    .join('\n');
};
